<template>

	<div class="set-location-wrapper">
		<SetLocation />
	</div>

	<div class="knd-legenda">
		<p class="knd-legenda-intro">

			Aantal 
			<span class="styled-dropdown">
				<select v-model="currentCat">
					<option
						v-for="cat in cats"
						:key='cat["label"]'
						:value='cat'>
						{{ cat["label"] }}
					</option>
				</select>
				<img 
					class="knd-button-icon" 
					:src="require('@/assets/icons/pijl.svg')" 
					alt="" />
			</span>

			dat je binnen 
			{{ currentCat["minutes"] }} 
			minuten kan bereiken:
		</p>

		<p v-if="gemGemeente" class="klein">Gemiddelde van alle buurten in de gemeente</p>

		<div class="knd-legenda-kleuren">
			<p>
				<span :style='{ "backgroundColor": kleuren[0].kleur }'>&emsp;</span>
				0
			</p>

			<p>
				<span :style='{ "backgroundColor": kleuren[1].kleur }'>&emsp;</span>
				1
			</p>

			<p>
				<span :style='{ "backgroundColor": kleuren[2].kleur }'>&emsp;</span>
				2
			</p>

			<p>
				<span :style='{ "backgroundColor": kleuren[3].kleur }'>&emsp;</span>
				3
			</p>
		</div>
	</div>

	<div class="knd-kaart-wrapper">

		<div ref="kaart"></div>
		<div class="knd-kaart-zoomuit">Zoom uit</div>
		<div id="knd-tooltip" class="hide"></div>

		<div ref="drawer" class="knd-drawer">
			<div v-if="showBuurtInfo">
				<p><b>{{ buurtSelected.properties["BU_NAAM"] }}</b></p>

				<div class="knd-drawer-info" v-if='buurtSelected.properties["Score_lt15min_Apotheken"] !== undefined'>
					<p>
						Bereikbaar met OV binnen een kwartier:
						<ul>
							<li>Huisartsen: 
								<span class="knd-highlight" :style='{ "backgroundColor": highlightBackground(buurtSelected.properties["Score_lt15min_Huisarts"]), "color": highlightColor(buurtSelected.properties["Score_lt15min_Huisarts"]) }'>
									{{ buurtSelected.properties["Score_lt15min_Huisarts"] }}
								</span>
							</li>
							<li>Apotheken: 
								<span class="knd-highlight" :style='{ "backgroundColor": highlightBackground(buurtSelected.properties["Score_lt15min_Apotheken"]), "color": highlightColor(buurtSelected.properties["Score_lt15min_Apotheken"]) }'>
									{{ buurtSelected.properties["Score_lt15min_Apotheken"] }}
								</span>
							</li>
							<li>Supermarkten: 
								<span class="knd-highlight" :style='{ "backgroundColor": highlightBackground(buurtSelected.properties["Score_lt15min_Supermarkt"]), "color": highlightColor(buurtSelected.properties["Score_lt15min_Supermarkt"]) }'>
									{{ buurtSelected.properties["Score_lt15min_Supermarkt"] }}
								</span>
							</li>
							<li>Basisscholen: 
								<span class="knd-highlight" :style='{ "backgroundColor": highlightBackground(buurtSelected.properties["Score_lt15min_Basisscholen"]), "color": highlightColor(buurtSelected.properties["Score_lt15min_Basisscholen"]) }'>
									{{ buurtSelected.properties["Score_lt15min_Basisscholen"] }}
								</span>
							</li>
							<li>Groen: 
								<span class="knd-highlight" :style='{ "backgroundColor": highlightBackground(buurtSelected.properties["Score_lt15min_Groen"]), "color": highlightColor(buurtSelected.properties["Score_lt15min_Groen"]) }'>
									{{ buurtSelected.properties["Score_lt15min_Groen"] }}
								</span>
							</li>
						</ul>
					</p>

					<p>
						
						Bereikbaar met OV binnen een half uur:
						<ul>
							<li>Ziekenhuizen: 
								<span class="knd-highlight" :style='{ "backgroundColor": highlightBackground(buurtSelected.properties["Score_lt30min_Ziekenhuis"]), "color": highlightColor(buurtSelected.properties["Score_lt30min_Ziekenhuis"]) }'>
									{{ buurtSelected.properties["Score_lt30min_Ziekenhuis"] }}
								</span>
							</li>
							<li>VBO/VMBO-scholen: 
								<span class="knd-highlight" :style='{ "backgroundColor": highlightBackground(buurtSelected.properties["Score_lt30min_VBO_VMBO"]), "color": highlightColor(buurtSelected.properties["Score_lt30min_VBO_VMBO"]) }'>
									{{ buurtSelected.properties["Score_lt30min_VBO_VMBO"] }}
								</span>
							</li>
							<li>HAVO/VWO-scholen: 
								<span class="knd-highlight" :style='{ "backgroundColor": highlightBackground(buurtSelected.properties["Score_lt30min_HAVO_VWO"]), "color": highlightColor(buurtSelected.properties["Score_lt30min_HAVO_VWO"]) }'>
									{{ buurtSelected.properties["Score_lt30min_HAVO_VWO"] }}
								</span>
							</li>
						</ul>
					</p>

					<p>
						Bereikbaar met OV binnen drie kwartier:
						<ul>
							<li>MBO-scholen: 
								<span class="knd-highlight" :style='{ "backgroundColor": highlightBackground(buurtSelected.properties["Score_lt45min_MBO"]), "color": highlightColor(buurtSelected.properties["Score_lt45min_MBO"]) }'>
									{{ buurtSelected.properties["Score_lt45min_MBO"] }}
								</span>
							</li>
							<li>Hogescholen of universiteiten: 
								<span class="knd-highlight" :style='{ "backgroundColor": highlightBackground(buurtSelected.properties["Score_lt45min_HBO_WO"]), "color": highlightColor(buurtSelected.properties["Score_lt45min_HBO_WO"]) }'>
									{{ buurtSelected.properties["Score_lt45min_HBO_WO"] }}
								</span>
							</li>
						</ul>
					</p>


				</div>
				<div class="knd-drawer-info" v-else>
					<p>Over jouw buurt is geen bereikbaarheidsinformatie beschikbaar.</p>
				</div>
				
			</div>
			<div class="knd-drawer-close" @click="hideDrawer()">
				<div class="knd-line knd-line-1"></div>
				<div class="knd-line knd-line-2"></div>
			</div>
		</div>

	</div>


</template>

<script>
	import Vervoerskaart from './kaart';
	import './kaart.scss';

	import SetLocation from '../set-location';

	const legenda = [
		{
			"kleur": "#FF5262",
			"tekst": "#fff",
			"value": 0
		},
		{
			"kleur": "#D0FFEB",
			"tekst": "#4D00FF",
			"value": 1
		},
		{
			"kleur": "#99EED0",
			"tekst": "#4D00FF",
			"value": 2
		},
		{
			"kleur": "#00DEB2",
			"tekst": "#fff",
			"value": 3
		}
	];

	const cats = [
		{
			"key": "Score_lt15min_Apotheken",
			"label": "apotheken",
			"minutes": 15
		},
		{
			"key": "Score_lt15min_Basisscholen",
			"label": "basisscholen",
			"minutes": 15
		},
		{
			"key": "Score_lt15min_Groen",
			"label": "groene plekken",
			"minutes": 15
		},
		{
			"key": "Score_lt15min_Huisarts",
			"label": "huisartsen",
			"minutes": 15
		},
		{
			"key": "Score_lt15min_Supermarkt",
			"label": "supermarkten",
			"minutes": 15
		},
		{
			"key": "Score_lt30min_HAVO_VWO",
			"label": "havo/vwo scholen",
			"minutes": 30
		},
		{
			"key": "Score_lt30min_VBO_VMBO",
			"label": "vbo/vmbo scholen",
			"minutes": 30
		},
		{
			"key": "Score_lt30min_Ziekenhuis",
			"label": "ziekenhuizen",
			"minutes": 30
		},
		{
			"key": "Score_lt45min_HBO_WO",
			"label": "hbo/wo scholen",
			"minutes": 45
		},
		{
			"key": "Score_lt45min_MBO",
			"label": "mbo scholen",
			"minutes": 45
		}
	]

	export default {
		name: 'Kaart',
		props: ['data'],
		data: function() {
			return {
				map: this.$store.state.map,
				mobiel: "haha",
				kaartRender: "test",
				showBuurtInfo: false,
				kleuren: legenda,
				gemGemeente: true,
				currentCat: ''
			}
		},
		computed: {
			cats() {
				return cats;
			},

			gemeenteSelected() {
				return this.$store.getters.gemeenteSelected;
			},

			buurtSelected() {
				return this.$store.getters.buurtSelected;
			}
		},
		methods: {
			loadGemeente(gemeente) {
				this.$store.dispatch('loadGemeente', gemeente);
				this.gemGemeente = false;
			},

			buurtClicked(buurt) {
				this.$store.dispatch('updateBuurt', buurt);
			},

			zoomOut() {
				this.gemGemeente = true;
			},

			checkMobiel() {
				const windowWidth = window.innerWidth;

				if (windowWidth < 500) {
					this.mobiel = true;
				}
			},

			updateKaart(gemeente) {
				this.$refs.drawer.classList.remove("up");
				this.$refs.drawer.classList.add("down");
				this.kaartRender.zoomToBounds(gemeente)
			},

			restyleKaart(cat) {
				this.kaartRender.restyleKaart(cat);
			},

			showDrawer(buurt) {
				// console.log("buurtinfo", buurt.properties);
				this.$refs.drawer.classList.remove("down");
				this.$refs.drawer.classList.add("up");
				// this.$refs.drawerText.innerHTML = "Info over " + buurt.properties["BU_NAAM"];
			},

			hideDrawer() {
				this.$refs.drawer.classList.remove("up");
				this.$refs.drawer.classList.add("down");
			},

			highlightBackground(value) {
				value = Math.round(value);
				const kleurFound = this.kleuren.find((kleur) => {
					return value == kleur.value;
				});

				let kleur;
				if (kleurFound) {
					kleur = kleurFound.kleur;
				}
				else {
					kleur = "#fff"	
				}
				return kleur;
			},

			highlightColor(value) {
				value = Math.round(value);
				const kleurFound = this.kleuren.find((kleur) => {
					return value == kleur.value;
				});

				let kleur;
				if (kleurFound) {
					kleur = kleurFound.tekst;
				}
				else {
					kleur = "#4D00FF"	
				}
				return kleur;
			}
		},
		mounted() {
			this.currentCat = cats[3];

			this.kaartRender = new Vervoerskaart()
				.container(this.$refs.kaart)
				.data(this.data)
				.legenda(this.kleuren)
				.catSelected(this.currentCat)
				.callBacks({
						"loadGemeente": this.loadGemeente,
						"buurtClicked": this.buurtClicked,
						"zoomOut": this.zoomOut
				})
				.render();

			//mobiel check
			window.addEventListener('resize', this.checkMobiel);
			this.checkMobiel();
		},
		watch: {
			currentCat: {
				handler(newValue) {
					this.restyleKaart(newValue);
				},
				deep: true
			},

			gemeenteSelected: {
				handler(newValue) {
					this.updateKaart(newValue);
				},
				deep: true
			},

			buurtSelected: {
				handler(newValue) {
					this.showDrawer(newValue);
					this.showBuurtInfo = true;
				},
				deep: true
			}
		},
		components: {
			SetLocation
		}
	}
</script>